import React from 'react'

const OtherPagesHero = (props) => {
  return (
    <div>
       <h1>{props.title}</h1>
  <p>{props.para1}</p>
  <p>{props.para2}</p>

    </div>
  )
}

export default OtherPagesHero
